// Tujuan: Konstanta global — API URL, frontend URL, dan semua enum dropdown (priceType, barcodeType, sourceOfSales, inoutType, sizeType, colorType, paperSize)
// Caller: Seluruh views, actions, dan komponen yang membutuhkan opsi dropdown / config URL
// Dependencies: Tidak ada (pure constant)
// Main Functions: Tidak ada (data constant)
// Side Effects: Tidak ada

const api_uri = {
  production: "https://api.dzakiraofficial.com/v1",
  // development: "https://api.dzakiraofficial.com/v1",
  // production: "http://localhost:5000/v1",
  development: "http://localhost:5000/v1",
};

const frontend_page_uri = {
  production: "https://dzakiraofficial.com",
  development: "http://localhost:3000",
};

const env = process.env.NODE_ENV;

export const apiURL = api_uri[env];
export const frontendPageURL = frontend_page_uri[env];

export const priceType = [
  {
    value: "priceRetail",
    label: "Harga Ritel",
  },
  {
    value: "priceReseller",
    label: "Harga Reseller",
  },
];

export const barcodeType = [
  {
    value: "Dzakira",
    label: "Dzakira",
  },
  {
    value: "Shopee",
    label: "Shopee",
  },
  {
    value: "Tiktok",
    label: "Tiktok",
  },
];

export const sourceOfSales = [
  {
    value: "Shopee PMA",
    label: "Shopee PMA",
  },
  {
    value: "Shopee",
    label: "Shopee",
  },
  {
    value: "Whatsapp",
    label: "Whatsapp",
  },
  {
    value: "Lazada",
    label: "Lazada",
  },
  {
    value: "Tiktok",
    label: "Tiktok",
  },
];

export const inoutType = [
  {
    value: "Pengeluaran",
    label: "Pengeluaran",
  },
  {
    value: "Pemasukan",
    label: "Pemasukan",
  },
];

export const sizeType = [
  {
    value: "NEW BORN",
    label: "NEW BORN",
  },
  {
    value: "XS",
    label: "XS",
  },
  {
    value: "S",
    label: "S",
  },
  {
    value: "M",
    label: "M",
  },
  {
    value: "L",
    label: "L",
  },
  {
    value: "XL",
    label: "XL",
  },
  {
    value: "XXL",
    label: "XXL",
  },
  {
    value: "TANPA UKURAN",
    label: "TANPA UKURAN",
  },
];

export const paperSize = [
  {
    value: "A3",
    label: "A3",
  },
];
